import { render, staticRenderFns } from "./AppCardActions.vue?vue&type=template&id=3c8cc567"
import script from "./AppCardActions.vue?vue&type=script&lang=js"
export * from "./AppCardActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports